document.querySelectorAll('[data-bundle-options]').forEach(group => {
  const form = group.closest('form');
  const sync = () => {
    const selected = group.querySelector('[data-bundle-variant]:checked');
    if (!selected) return;
    // The product headline stays at the single-toy price; each offer shows its total.
    const gifts = form.querySelector('[data-bundle-gifts]');
    if (gifts) { gifts.value = selected.dataset.gifts || ''; gifts.disabled = !gifts.value; }
    const submit = form.querySelector('[type="submit"]');
    submit.disabled = selected.dataset.available !== 'true';
    submit.textContent = submit.disabled ? 'Sold out' : 'Add bundle to bag →';
    group.querySelectorAll('.bundle-option').forEach(label => label.classList.toggle('is-selected',label.contains(selected)));
  };
  group.addEventListener('change',sync);
  sync();
});
